import { render, staticRenderFns } from "./Especie.vue?vue&type=template&id=47e37010&"
import script from "./Especie.vue?vue&type=script&lang=js&"
export * from "./Especie.vue?vue&type=script&lang=js&"
import style0 from "./Especie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports